import React from 'react';
import { fetchProductList, getProductById, mapProductToCard } from './BundleApi';
import { Box, Button } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import {QuickSearchToolbar} from 'Components/DataGrid/Toolbars';
import { BundleContext } from './BundleContext';


export default function ProductSelector({ onCardObjectSelected }) {
    return (
            <ProductList onCardObjectSelected={onCardObjectSelected} />
    );
}

function ProductList({ onCardObjectSelected }) {
    const [productList, setProductList] = React.useState([]);
    const { getCardIdReferenceCount } = React.useContext(BundleContext)

    React.useEffect(() => {
        (async () => {
            const data = await fetchProductList();
            setProductList(data);
        })();
    }, []);

    function selectRow(row) {
        (async () => {
            const product = await getProductById(row.id);
            const card = mapProductToCard(product);
            onCardObjectSelected(card);
        })();
    }

    const columns = [
        {
            field: 'id',
            headerName: 'Product Id',
            flex : 0.5,
            editable: false,
        },
        {
            field: 'name',
            headerName: 'Name',
            flex: 1,
        },
        {
            field: 'location',
            headerName: 'Location',
            flex: 0,
            valueGetter: (params) => {
                const location = params?.row?.productCities?.[0];
                return [location?.country || '-', location?.city || '-'].join(', ');
            },
        },
        {
            field: 'refernceCount',
            headerName: 'Used',
            flex: 0,
            valueGetter : (params) => getCardIdReferenceCount(params.row.id) || '-'

        },
        {
            field: 'action',
            headerName: 'Action',
            sortable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    selectRow(params.row);
                };

                return (
                    <Button variant="contained" color="primary" onClick={onClick}>
                        Assign
                    </Button>
                );
            },
        },
    ];

    return (
        <>
            <Box sx={{ flex: 1 }}>
                <DataGridPro
                    rows={productList}
                    onRowClick={selectRow}
                    columns={columns}
                    pagination={true}
                    pageSize={10}
                    components={{ Toolbar: QuickSearchToolbar }}
                    initialState={{
                        sorting: {
                            sortModel: [{ field: 'location', sort: 'desc' }],
                        },
                    }}
                    sx={{
                        '.MuiDataGrid-columnHeaders': {
                            fontWeight: 'bold',
                            fontSize: 14,
                            color: 'rgb(0,0,0)',
                            backgroundColor: 'rgb(244,246,248)',
                        },
                        '.MuiTablePagination-selectLabel': {
                            marginBottom: '0px',
                        },
                        '.MuiTablePagination-displayedRows': {
                            marginBottom: '0px',
                        },
                        '.MuiPaper-root.div.span': {
                            color: 'blue',
                        },
                    }}
                />
            </Box>
        </>
    );
}

